// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NavigationArrowRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11">
            <path
                fill="currentColor"
                d="M1.13340735,0.205050577 L5.04629815,4.36130058 C5.16592705,4.48776542 5.22572774,4.65005051 5.22572774,4.81247245 C5.22572774,4.97481262 5.16589951,5.13704263 5.04629815,5.26364433 L1.13340735,9.41989433 C0.884032488,9.68239449 0.468680858,9.69333183 0.205634117,9.44450354 C-0.0592722299,9.19499182 -0.0686236623,8.77786278 0.179999351,8.51645659 L3.69093668,4.81137847 L0.179999351,1.10630034 C-0.0686236623,0.84489416 -0.0593268874,0.430636514 0.205634117,0.179347385 C0.468680858,-0.0692072022 0.884032488,-0.0582698691 1.13340735,0.205050577 Z"
                transform="translate(.313 .938)"
            />
        </svg>
    );
};

export default React.memo(NavigationArrowRight);
